import { handleContractorProceed } from "../utils/handleContractorProceed";
import { handleContractorBack } from "../utils/handleContractorBack";
import { useAppDispatch } from "../../../app/hooks";
import ContractorInterface from "../../../common/interfaces/ContractorInterface";
import { ContractorEnum } from "../../../common/constants/ContractorEnum";
import { JSX } from "react";

interface Props {
    slug?: string;
    contractors?: object[];
    activeContractorId?: number | null;
    type: ContractorEnum;
}

export const ContractorNotice = (props: Props): JSX.Element => {
    const { slug, contractors, activeContractorId, type } = props;
    const dispatch = useAppDispatch();

    const selectedContractor = contractors?.find(
        (c: ContractorInterface) => c.id === (activeContractorId ?? -1),
    ) as ContractorInterface | undefined;

    const leaseData = {
        title: "Schade melden bij je leasemaatschappij",
        intro1: "Voor deze leasemaatschappij dien je de schade op het eigen platform te melden. Nadat je daar je schade hebt gemeld, word je doorverwezen naar een ABS-vestiging voor de reparatie.",
        intro2: "Klik op de onderstaande knop om door te gaan naar het platform van je leasemaatschappij.",
        ctaSuffix: "leasemaatschappij",
        backLabel: "Kies andere leasemaatschappij",
        warn: "Let op: Je gegevens worden niet automatisch gedeeld met de leasemaatschappij. Je dient relevante informatie opnieuw in te voeren bij het melden van je schade.",
    };

    const insuranceData = {
        title: "Schade melden bij je verzekeraar",
        intro1: "Voor deze verzekeraar dien je de schade op het eigen platform te melden. Nadat je daar je schade hebt gemeld, word je doorverwezen naar een ABS-vestiging voor de reparatie.",
        intro2: "Klik op de onderstaande knop om door te gaan naar het platform van je verzekeraar.",
        ctaSuffix: "verzekeraar",
        backLabel: "Kies andere verzekeraar",
        warn: "Let op: Je gegevens worden niet automatisch gedeeld met de verzekeraar. Je dient relevante informatie opnieuw in te voeren bij het melden van je schade.",
    };

    const data = type === ContractorEnum.LEASE ? leaseData : insuranceData;
    const { title, intro1, intro2, ctaSuffix, backLabel, warn } = data;

    return (
        <div className="s-appointment__group border-color-primary">
            <h1 className="s-appointment__group__title">{title}</h1>
            <p>{intro1}</p>
            <p>{intro2}</p>
            <div className="c-form__buttons c-form__buttons--row">
                <button
                    type="button"
                    onClick={() =>
                        handleContractorProceed({
                            dispatch,
                            slug,
                            contractors,
                            activeContractorId,
                        })
                    }
                    className="c-form__buttons__single c-form__buttons__single___primary background-primary"
                >
                    <span className="font-face-primary">
                        Ga naar {selectedContractor?.name ?? ctaSuffix}
                    </span>
                </button>
                <button
                    type="button"
                    onClick={() =>
                        handleContractorBack({
                            dispatch,
                            type,
                        })
                    }
                    className="c-form__buttons__single c-form__buttons__single border-color-primary border-color-primary-hover"
                    style={{ marginLeft: "1rem" }}
                >
                    <span className="font-face-primary">{backLabel}</span>
                </button>
            </div>
            <p style={{ marginTop: "1rem", fontSize: "1.3rem" }}>{warn}</p>
        </div>
    );
};
